import { Link } from "react-router-dom";

const ENTRIES = [
  {
    type: "teleplay",
    label: "电视剧",
    desc: "都市、年代、古装，追剧不停歇",
    icon: "ri-tv-2-line",
    count: "12,800+ 部",
  },
  {
    type: "movie",
    label: "电影",
    desc: "院线热映与经典佳片精选",
    icon: "ri-film-line",
    count: "9,600+ 部",
  },
  {
    type: "variety",
    label: "综艺",
    desc: "音乐、户外、美食真人秀",
    icon: "ri-mic-2-line",
    count: "3,400+ 档",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/60 p-5 md:p-6 transition-colors cursor-pointer"
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <span className="w-11 h-11 rounded-lg bg-primary-500/15 text-primary-400 flex items-center justify-center mb-3">
                <i className={`${entry.icon} text-2xl`} />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{entry.label}</h3>
              <p className="text-xs text-foreground-600 mt-1.5 leading-relaxed">{entry.desc}</p>
            </div>
            <span className="font-label text-xs text-foreground-600 whitespace-nowrap">{entry.count}</span>
          </div>
          <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-400 font-medium">
            进入频道
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
          </span>
          <i className="ri-arrow-right-up-line absolute -bottom-4 -right-2 text-7xl text-background-200/60 group-hover:text-primary-500/10 transition-colors" />
        </Link>
      ))}
    </div>
  );
}